import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
import switches from './switches'
/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::validateMapping
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:133
* @route '/motels/{motel}/channel-manager/validate-mapping'
*/
export const validateMapping = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: validateMapping.url(args, options),
    method: 'post',
})

validateMapping.definition = {
    methods: ["post"],
    url: '/motels/{motel}/channel-manager/validate-mapping',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::validateMapping
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:133
* @route '/motels/{motel}/channel-manager/validate-mapping'
*/
validateMapping.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return validateMapping.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::validateMapping
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:133
* @route '/motels/{motel}/channel-manager/validate-mapping'
*/
validateMapping.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: validateMapping.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::validateMapping
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:133
* @route '/motels/{motel}/channel-manager/validate-mapping'
*/
const validateMappingForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: validateMapping.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::validateMapping
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:133
* @route '/motels/{motel}/channel-manager/validate-mapping'
*/
validateMappingForm.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: validateMapping.url(args, options),
    method: 'post',
})

validateMapping.form = validateMappingForm

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::resync
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:164
* @route '/motels/{motel}/channel-manager/resync'
*/
export const resync = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resync.url(args, options),
    method: 'post',
})

resync.definition = {
    methods: ["post"],
    url: '/motels/{motel}/channel-manager/resync',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::resync
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:164
* @route '/motels/{motel}/channel-manager/resync'
*/
resync.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return resync.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::resync
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:164
* @route '/motels/{motel}/channel-manager/resync'
*/
resync.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resync.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::resync
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:164
* @route '/motels/{motel}/channel-manager/resync'
*/
const resyncForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resync.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::resync
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:164
* @route '/motels/{motel}/channel-manager/resync'
*/
resyncForm.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resync.url(args, options),
    method: 'post',
})

resync.form = resyncForm

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::probe
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:176
* @route '/motels/{motel}/channel-manager/probe'
*/
export const probe = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: probe.url(args, options),
    method: 'post',
})

probe.definition = {
    methods: ["post"],
    url: '/motels/{motel}/channel-manager/probe',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::probe
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:176
* @route '/motels/{motel}/channel-manager/probe'
*/
probe.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return probe.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::probe
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:176
* @route '/motels/{motel}/channel-manager/probe'
*/
probe.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: probe.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::probe
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:176
* @route '/motels/{motel}/channel-manager/probe'
*/
const probeForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: probe.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::probe
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:176
* @route '/motels/{motel}/channel-manager/probe'
*/
probeForm.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: probe.url(args, options),
    method: 'post',
})

probe.form = probeForm

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::refreshProperty
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:204
* @route '/motels/{motel}/channel-manager/refresh-property'
*/
export const refreshProperty = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refreshProperty.url(args, options),
    method: 'post',
})

refreshProperty.definition = {
    methods: ["post"],
    url: '/motels/{motel}/channel-manager/refresh-property',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::refreshProperty
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:204
* @route '/motels/{motel}/channel-manager/refresh-property'
*/
refreshProperty.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return refreshProperty.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::refreshProperty
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:204
* @route '/motels/{motel}/channel-manager/refresh-property'
*/
refreshProperty.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refreshProperty.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::refreshProperty
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:204
* @route '/motels/{motel}/channel-manager/refresh-property'
*/
const refreshPropertyForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refreshProperty.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::refreshProperty
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:204
* @route '/motels/{motel}/channel-manager/refresh-property'
*/
refreshPropertyForm.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refreshProperty.url(args, options),
    method: 'post',
})

refreshProperty.form = refreshPropertyForm

const channelManager = {
    validateMapping: Object.assign(validateMapping, validateMapping),
    resync: Object.assign(resync, resync),
    probe: Object.assign(probe, probe),
    refreshProperty: Object.assign(refreshProperty, refreshProperty),
    switches: Object.assign(switches, switches),
}

export default channelManager